import React, {useEffect, useState} from "react";
import ReactDOM from "react-dom/client";
import {Question} from "survey-core";
import DatePicker from "patient-ping-remedy/packages/date-picker";
import {Wrapper} from "@common/survey_js/CustomDateWidget.styles";
import DisplayHelpers from "@/helpers/display_helpers";

export const datePickerWidgetName = "custom-datepicker";

const CustomDatePicker: React.FC<{ question: Question }> = ({ question }) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleChange = (date: Date | null) => {
    setSelectedDate(date);
    question.value = date;
    return date;
  };

  const handleQuestionChange = () => {
    let currentValue = null;

    if (question.value instanceof Date) {
      currentValue = question.value;
    } else if (typeof question.value === 'string') {
      currentValue = DisplayHelpers.parseDateOnly(question.value.slice(0, 10));
    }

    setSelectedDate(currentValue);
  };

  useEffect(() => {
    handleQuestionChange();
    question.valueChangedCallback = handleQuestionChange;
  }, []);

  return (
    <Wrapper>
      <DatePicker
        id={question.name}
        onChange={handleChange}
        value={selectedDate}
        labelText={question.title}
        disabled={question.readOnly}
        required={question.isRequired ? "required" : undefined}
        maxDate={new Date()}
      />
    </Wrapper>
  );
};

export type CustomDatePickerQuestion = Question & {
  __datepickerRoot?: ReactDOM.Root;
}

export const CustomDateWidget = {
  name: datePickerWidgetName,
  title: "Custom Datepicker",
  widgetIsLoaded: () => true,
  isFit: (question: CustomDatePickerQuestion) =>
    question.inputType === "date" && question.customComponent === datePickerWidgetName,
  afterRender: (question: CustomDatePickerQuestion, el: HTMLElement) => {
    if (!question.__datepickerRoot) {
      const container = document.createElement('div');
      el.appendChild(container);
      question.__datepickerRoot = ReactDOM.createRoot(container);
    }
    question.__datepickerRoot.render(<CustomDatePicker question={question} />);
  },
  willUnmount: (question: CustomDatePickerQuestion) => {
    if (question.__datepickerRoot) {
      const root = question.__datepickerRoot;
      question.__datepickerRoot = undefined;
      setTimeout(() => {
        root.unmount();
      });
    }
  },
};
